import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=1d6f0991&"
import script from "./UserHeader.vue?vue&type=script&lang=ts&"
export * from "./UserHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports